import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { navigate } from '../lib/router';

// Gate protected routes. Redirects to /login when unauthenticated.
export default function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  useEffect(() => {
    if (!loading && !user) navigate('/login');
  }, [loading, user]);

  if (loading) return <div className="state state--loading">Loading…</div>;
  if (!user) return null;
  return children;
}
